module.exports = __webpack_public_path__ + "img/ErsteKarateprüfung.5addf6c1.jpg";